import colormerize from '../../images/colormerize_square.png';
import tictactoe from '../../images/tictactoe.png';
import rps from '../../images/rpsbackground.png';
import minesweeper from '../../images/minesweeper_color.png';

export const GameData = [
    {
        name: "Memory Game",
        img: colormerize,
        link: "https://splendorous-sundae-769eb0.netlify.app"
    },
    {
        name: "Tic Tac Toe",
        img: tictactoe,
        link: "https://dancing-malasada-fa3516.netlify.app/"
    },
    {
        name: "Rock Paper Scissors",
        img: rps,
        link: "https://rainbow-crisp-cecb77.netlify.app"
    },
    {
        name: "Minesweeper",
        img: minesweeper,
        link: "https://iridescent-sprinkles-24ea35.netlify.app"
    }
]